import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getPDF } from "store/swList/swListActions";
import { showErrorToast, showInfoToast } from "store/toast/toastActions";
import useSelector from "store/useSelector";

interface IDownloadLatestPdfByGuid {

}

const DownloadLatestPdfByGuid: React.FC<IDownloadLatestPdfByGuid> = (props) => {
    const {swGuid: guidFromParams} = useParams();
    const swGuid = window.decodeURIComponent(guidFromParams!);
    const dispatch = useDispatch();
    const {
        getPDFData: {
            getPdfOperation,
        }
    } = useSelector(store => store.swList);

    useEffect(() => {
        dispatch(
            getPDF({
                swId: 0,
                swGuid: swGuid,
                generateDefault: true,
                getLatestVersion: true,
            })
        );
    }, [swGuid, dispatch]);

    if (getPdfOperation?.errorMessage) {
        dispatch(showErrorToast("Error getting PDF"));
    } else if (getPdfOperation?.wasSuccessful) {
        dispatch(showInfoToast("PDF generated & downloaded successfully"));
    }

    return <></>;
}

export default DownloadLatestPdfByGuid;